
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M46.511 22.995c-.01-.09-.02-.17-.05-.26l-.03-.089a.833.833 0 00-.2-.288l-7.949-7.915c-.09-.09-.19-.15-.29-.2l-.09-.03c-.08-.03-.17-.04-.25-.05-.02 0-.04-.01-.07-.01H20.505a1 1 0 00-1 .996v34.238a1 1 0 001 .996h25.026a1 1 0 001-.996V23.064c-.01-.03-.02-.05-.02-.07zm-7.939-5.446l4.54 4.52h-4.54v-4.52zM21.495 48.392V16.145h15.077v6.92a1 1 0 001 .995h6.95v24.332H21.494z"}}),_c('path',{attrs:{"d":"M34.283 10.72a1 1 0 00-1-.996H15.106a1 1 0 00-1 .995v35.612a1 1 0 002 0V11.715h17.177c.56 0 1-.448 1-.996z"}})])
          )
        }
      }
    